var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"nav-box"}),_c('div',{staticClass:"details-wrap"},[_c('p',[_vm._v(" "+_vm._s(_vm.details[_vm.count].text)+" ")]),_c('p',[_c('img',{attrs:{"src":_vm.details[_vm.count].imgSrc,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }